import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The theme's custom font sizes (tailwind.config.js `fontSize`) have to be
// declared here: unknown, tailwind-merge reads `text-body` as a text color and
// drops whichever real color sits next to it (e.g. FieldError's
// `text-destructive`).
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["display", "heading", "subheading", "base", "body", "caption"],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
